"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSerializer = void 0;
class UserSerializer {
    serializeOne({ id, userId, globalId, name, avatar, school, roles, district, archived, grade, }) {
        return {
            id,
            userId,
            globalId,
            district,
            firstName: name ? name.first : undefined,
            lastName: name ? name.last : undefined,
            roles,
            avatar,
            school: (school && school.length ? school[0] : undefined),
            schools: school,
            archived,
            grade,
        };
    }
    serializeOneWithClasses({ id, userId, globalId, name, avatar, school, roles, district, archived, grade, classes, }) {
        return {
            id,
            userId,
            globalId,
            district,
            firstName: name ? name.first : undefined,
            lastName: name ? name.last : undefined,
            roles,
            avatar,
            school: (school && school.length ? school[0] : undefined),
            schools: school,
            archived,
            grade,
            classes: this.serializeStudentClasses(classes),
        };
    }
    serializeStudentClasses(classes) {
        return (classes || []).map((singleClass) => ({
            id: singleClass.id,
            name: singleClass.name,
        }));
    }
    serializeOnePrimaryTeacher({ id, userId, globalId, name, email, username, }) {
        return {
            id,
            userId,
            globalId,
            username,
            firstName: name ? name.first : undefined,
            lastName: name ? name.last : undefined,
            email,
        };
    }
    serializeOneStudentFromList({ id, userId, globalId, firstName, lastName, district, }) {
        return {
            id,
            userId,
            globalId,
            district: district ? district : undefined,
            firstName,
            lastName,
        };
    }
}
exports.UserSerializer = UserSerializer;
//# sourceMappingURL=user.serializer.js.map